import React from 'react'

import Module from './Module';
import SearchField from '../../components/SearchField';

const Modules = (props) => {

    const handleModuleQueryChange = (query) => {
        props.updateModuleQuery(query);
    };

    return <div className="card">
        <div className="card-body">
            <h4 className="card-title">Module</h4>
            <div className="row">
                <div className="col-3">
                    <SearchField className="mb-2 mr-sm-2 mb-sm-0" value={props.query} onCommit={handleModuleQueryChange}/>
                </div>
                <div className="col-12">
                    <button type="button" className="btn btn-light float-right"
                            onClick={props.showModuleModal}>
                        <i className="fa fa-plus-circle"/>&nbsp;neues Modul
                    </button>
                </div>
            </div>
            <table className="table table-striped">
                <thead>
                <tr>
                    <th>Modul</th>
                    <th>Nachversorgungs-Zeitraum</th>
                    <th style={{minWidth: '200px'}}>Kontrakt</th>
                    <th style={{minWidth: '150px'}}>Sortiment</th>
                    <th>NOS</th>
                    <th>Aktionen</th>
                </tr>
                </thead>
                <tbody>
                {props.modules.map((module) => {
                    return <Module {...module}
                                   key={module.id}
                                   deleteModule={props.deleteModule}
                                   showModulesArticles={props.showModulesArticles}
                                   showModulesStores={props.showModulesStores}
                                   updateModuleReplenishmentPeriod={props.updateModuleReplenishmentPeriod}
                                   activateUnlimitedStock={props.activateUnlimitedStock}
                                   deactivateUnlimitedStock={props.deactivateUnlimitedStock}
                                   updateModuleAssortment={props.updateModuleAssortment}
                                   updateModuleContract={props.updateModuleContract}/>
                })}
                </tbody>
            </table>
        </div>
    </div>;
};

export default Modules;



// WEBPACK FOOTER //
// ./src/admin/module/overview/Modules.js